import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { toast } from 'sonner';
import api from '../../api';

export default function InformeIvaVerPage() {
  const { runId } = useParams();
  const [html, setHtml] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      setLoading(true);
      try {
        const previewRes = await api.get(`/informes-iva/preview/${runId}`, { responseType: 'text' });
        if (!cancelled) setHtml(previewRes.data);
      } catch (e) {
        if (!cancelled) toast.error(e.response?.data?.error || 'No se pudo cargar el informe');
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [runId]);

  const descargarPdf = async () => {
    try {
      const res = await api.get(`/informes-iva/pdf/${runId}`, { responseType: 'blob' });
      const url = window.URL.createObjectURL(new Blob([res.data], { type: 'application/pdf' }));
      const a = document.createElement('a');
      a.href = url;
      a.download = `informe-iva-${runId}.pdf`;
      a.click();
      window.URL.revokeObjectURL(url);
    } catch (e) {
      toast.error(e.response?.data?.error || 'No se pudo generar el PDF');
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-100 text-slate-600">
        Cargando informe…
      </div>
    );
  }

  if (!html) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center gap-4 p-6">
        <p>No se encontró el informe.</p>
        <Link to="/informes-iva" className="text-indigo-600 underline">
          Volver a Informes IVA
        </Link>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex flex-col bg-slate-200">
      <div className="sticky top-0 z-10 bg-white border-b border-slate-200 shadow-sm px-4 py-3 flex flex-wrap items-center gap-3">
        <Link to="/informes-iva" className="text-sm text-slate-600 hover:text-slate-900">
          ← Volver al panel
        </Link>
        <button
          type="button"
          onClick={descargarPdf}
          className="ml-auto px-4 py-2 text-sm font-medium bg-indigo-600 text-white rounded-lg hover:bg-indigo-700"
        >
          Descargar PDF
        </button>
      </div>
      <iframe
        title="Informe IVA"
        srcDoc={html}
        className="flex-1 w-full min-h-[calc(100vh-56px)] bg-white border-0"
        sandbox="allow-same-origin"
      />
    </div>
  );
}
